import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { Match, MatchStoreState } from '../../../../../services/interfaces';
import { translateEntity } from '../../../../../services/utils';
import {
  getMatchWording,
  isLiveMatch,
  isLiveMatchPenalties,
  isUpcomingMatch,
  lineupStatus,
  matchMinute,
  phaseIsPrintable,
  setCssVariant,
  statusIsPrintable,
} from '../../helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchStatusInfo = ({ state }: Props): HTMLDivElement => {
  const size = state.size;
  const cssVariant = setCssVariant(size);
  const match: Match = state.matchData;
  if (!match) return null;

  if (
    !phaseIsPrintable(match) &&
    !(isUpcomingMatch(match.status) && lineupStatus(match)) &&
    !statusIsPrintable(match) &&
    (!isLiveMatch(match.status) || isLiveMatchPenalties(match.status, match.phase))
  ) {
    return null;
  }

  return (
    <div class={{ 'pk-match__status--info': true, ...cssVariant }} part="status-info">
      {phaseIsPrintable(match) && (
        <div class={{ 'pk-match__status--phase': true, ...cssVariant }} part="status-phase">
          {translateEntity(match)?.phaseName}
        </div>
      )}
      {isUpcomingMatch(match.status) && (
        <div class={{ 'pk-match__status--lineups': true, ...cssVariant }} part="status-lineups">
          {lineupStatus(match)}
        </div>
      )}
      {statusIsPrintable(match) && (
        <div class={{ 'pk-match__status--cp': true, ...cssVariant }} part="status-cp">
          {getMatchWording(match.status.toLowerCase())}
        </div>
      )}
      {isLiveMatch(match.status) && (
        <span class={{ 'pk-match__status--minute': true, ...cssVariant }} part="status-minute">
          {matchMinute(match)}
        </span>
      )}
    </div>
  );
};

export { MatchStatusInfo };
